import { Box } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { Scrollbar } from '@app/components';
import { useRequestState } from '@app/hooks';
import { selectMyProfileFormState } from '@app/modules/my-profile';
import { getBoardDetails, getTransaction } from '@app/modules/task-board/slice';
import { selectTransactionState } from '@app/modules/task-board/selector';
import { TaskInfo } from './task-info';
import { CheckListAndTransactionCard } from './checklist-and-transaction-card';
import { CommentSectionCard } from './comment-section-card';
import { getMyTaskDetails } from '../slice';
import { selectMyTaskDetailsState } from '../selector';

const TasksDetailsPage = () => {
  const { state } = useLocation();
  const task = state.row;

  const dispatch = useDispatch();

  const { data: UserInfo } = useRequestState({
    stateSelector: selectMyProfileFormState,
    errorShown: true,
  });

  useEffect(() => {
    if (task && UserInfo) {
      dispatch(
        getMyTaskDetails({
          userId: UserInfo?.id,
          boardId: task?.boardId,
          listId: task?.listId,
          cardId: task?.id,
        })
      );
      dispatch(getBoardDetails(task?.boardId));
    }
  }, [task, dispatch, UserInfo]);

  const { data } = useRequestState({
    stateSelector: selectMyTaskDetailsState,
    errorShown: true,
  });

  const goBack = () => {
    history.back();
  };

  useEffect(() => {
    if (task?.id) {
      dispatch(getTransaction({ cardId: task?.id }));
    }
  }, [dispatch, task?.id]);

  const { data: transactionsData } = useRequestState({
    stateSelector: selectTransactionState,
    errorShown: true,
  });

  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header goBack={goBack} title={Strings.page_title.details} helperText={''} />
      </Box>
      <Scrollbar>
        <TaskInfo taskData={data} />
        <CheckListAndTransactionCard
          checkLists={data?.checklists}
          transactions={transactionsData || []}
        />
        {data?.comments?.length > 0 && <CommentSectionCard comments={data?.comments} />}
      </Scrollbar>
    </>
  );
};
export { TasksDetailsPage };
